<div class="mt-8 space-y-16">
    @if (linksSuccess().length) {
        <ng-container
            [ngTemplateOutlet]="links"
            [ngTemplateOutletContext]="{
                label:
                    linksSuccess().length
                    | i18nPlural
                        : {
                              '=1': labelRoot + 'SUMMARY_VALID_SING',
                              other: labelRoot + 'SUMMARY_VALID_PLUR',
                          }
                    | translate: { count: linksSuccess().length },
                links: [],
            }"
        />
    }

    @if (linksErrorValidation().length > 0) {
        <ng-container
            [ngTemplateOutlet]="links"
            [ngTemplateOutletContext]="{
                label: labelRoot + 'SUMMARY_INVALID' | translate,
                links: linksErrorValidation(),
            }"
        />
    }

    @if (linksErrorConcurrency().length > 0) {
        <ng-container
            [ngTemplateOutlet]="links"
            [ngTemplateOutletContext]="{
                label: labelRoot + 'SUMMARY_CONCURRENCY' | translate,
                links: linksErrorConcurrency(),
            }"
        />
    }
</div>

<interacta-dialog-buttons>
    <button
        interacta-dialog-button
        type="button"
        [label]="'RELATIONS_DIALOG.BACK_BUTTON' | translate"
        [style]="'text'"
        (click)="back.emit()"
    ></button>
</interacta-dialog-buttons>

<ng-template #links let-label="label" let-links="links">
    <div>
        <p class="typo-sm">{{ label }}</p>
        @if (links?.length > 0) {
            <ul class="list-inside list-disc typo-sm">
                @for (link of links; track link.id) {
                    <li class="mt-2">{{ link.title }}</li>
                }
            </ul>
        }
    </div>
</ng-template>
